import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { LeaveDto } from './leave-dto.model';
import { TransactionStatus } from '../service-proxies';


export class LeaveApplicationDto implements ILeaveApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    leaveRequestDate!: Date;
    leaveType!: LeaveDto;
    fromDateTime!: Date;
    toDateTime!: Date;
    leaveReason!: string | undefined;
    requestDays!: number;
    leaveStatus!: TransactionStatus;
    leaveStatusType!: string | undefined;

    constructor(data?: ILeaveApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.leaveRequestDate = _data["leaveRequestDate"] ? new Date(_data["leaveRequestDate"].toString()) : <any>undefined;
            this.leaveType = _data["leaveType"] ? LeaveDto.fromJS(_data["leaveType"]) : <any>undefined;
            this.fromDateTime = _data["fromDateTime"] ? new Date(_data["fromDateTime"].toString()) : <any>undefined;
            this.toDateTime = _data["toDateTime"] ? new Date(_data["toDateTime"].toString()) : <any>undefined;
            this.leaveReason = _data["leaveReason"];
            this.requestDays = _data["requestDays"];
            this.leaveStatus = _data["leaveStatus"];
            this.leaveStatusType = _data["leaveStatusType"];
        }
    }

    static fromJS(data: any): LeaveApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["leaveRequestDate"] = this.leaveRequestDate ? this.leaveRequestDate.toISOString() : <any>undefined;
        data["leaveType"] = this.leaveType ? this.leaveType.toJSON() : <any>undefined;
        data["fromDateTime"] = this.fromDateTime ? this.fromDateTime.toISOString() : <any>undefined;
        data["toDateTime"] = this.toDateTime ? this.toDateTime.toISOString() : <any>undefined;
        data["leaveReason"] = this.leaveReason;
        data["requestDays"] = this.requestDays;
        data["leaveStatus"] = this.leaveStatus;
        data["leaveStatusType"] = this.leaveStatusType;
        return data; 
    }
}

export interface ILeaveApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    leaveRequestDate: Date;
    leaveType: LeaveDto;
    fromDateTime: Date;
    toDateTime: Date;
    leaveReason: string | undefined;
    requestDays: number;
    leaveStatus: TransactionStatus;
    leaveStatusType: string | undefined;
}

